import * as React from 'react'
import Store from 'store'
import { observer, inject } from 'mobx-react'
import { News as Setting, Login } from '@services/api'

import AccountForm from './AccountForm'
import AppListDialog from '../components/AppListDialog'
import { queryOperationList, setStore, appId } from '../OneLogin/OneLoginForm'
import { IProps } from './index'
import { getHomeList } from '../Login/helper'
import {
  LoginBodyCodeEnum,
  IIdentytyItem,
  IIdentytySelectItem,
} from '../Login/type'
import { transform } from '@utils/intl_lang'
const initialState = {
  loginLoading: false,
  appListDialogVisible: false,
  cellphoneNumber: '',
  dialogData: [] as IIdentytySelectItem[],
}

interface IState extends Readonly<typeof initialState> {}

@inject('UserStore', 'AppStore')
@observer
class BindingForm extends React.Component<IProps, IState> {
  public state = initialState

  public render() {
    const { appListDialogVisible, dialogData, loginLoading } = this.state
    return (
      <>
        <AccountForm
          headText="HELLO"
          // "绑定手机"
          description={transform('Login_bind_mobile_phone')}
          requestType="12" // 1代表注册，2代表找回密码，12账号绑定手机号码并绑定对应的企业身份
          // "确 定"
          nextLabel={transform('confirm_txt')}
          handleComplete={this.handleComplete}
          confirmPwdLoading={!appListDialogVisible && loginLoading}
          needAgreement={true}
          {...this.props}
        />
        {appListDialogVisible && (
          <AppListDialog
            data={dialogData}
            // "身份"
            title={transform('Login_identity')}
            loading={appListDialogVisible && loginLoading}
            handleSelect={this.handleSelectApp}
          />
        )}
      </>
    )
  }

  private handleSelectApp = (enterpriseId: string) => async () => {
    // 选择身份
    const { dialogData } = this.state
    const item = dialogData.find(d => d.value === enterpriseId)
    if (!item) {
      return
    }
    this.props.UserStore.updateIdentity(enterpriseId, item.title) // 根据身份更新企业ID及名称
    Store.set('sessionInfo', {
      ...Store.get('sessionInfo'),
      enterpriseId,
      enterpriseName: item.title,
    })
    const empId = item.empId
    const result = await Setting.enterpriseIsActive(appId, empId, enterpriseId) // 校验权限

    if (+result.code !== 0) {
      global.$message(result.message)
      return
    }
    if (+result.body.isSuccess === 1) {
      this.setState({ loginLoading: true })
      const result1 = await Login.sidIsEffective() // 登录
      const bodyCode = result1.body.bodyCode
      this.setState({ loginLoading: false })

      if (+result1.code !== 0) {
        global.$message(result1.message)
        return
      }
      setStore(result1.body)
      queryOperationList()
      if (
        bodyCode === LoginBodyCodeEnum.VALID ||
        bodyCode === LoginBodyCodeEnum.VALID_WITH_NOT_IDENTITY
      ) {
        // 无企业身份也可登录
        // 正常登录，跳首页
        const { history, AppStore } = this.props
        getHomeList({ history, AppStore })
      } else {
        this.props.history.push('/noPermission/1')
      }
    }
  }
  private handleComplete = async () => {
    // 登录
    const { params } = this.props.match
    this.yizhangtongLogin(params.token)
  }

  private yizhangtongLogin = async (token: string) => {
    const { code, message, body } = await Login.yztLogin({ token })
    const bodyCode = body.bodyCode
    if (+code !== 0) {
      this.setState({ appListDialogVisible: false })
      global.$message(message)
      return
    }

    setStore(body)
    queryOperationList()
    if (
      bodyCode === LoginBodyCodeEnum.VALID ||
      bodyCode === LoginBodyCodeEnum.VALID_WITH_NOT_IDENTITY
    ) {
      const { history, AppStore } = this.props
      getHomeList({ history, AppStore })
    } else if (bodyCode === LoginBodyCodeEnum.MULTI_IDENTITY) {
      if (body.userArr.length) {
        const dialogData = body.userArr.map((item: IIdentytyItem) => ({
          title: item.enterpriseName,
          value: item.enterpriseId,
          empId: item.empId,
        }))
        this.setState({
          appListDialogVisible: true,
          dialogData,
        })
      }
    } else {
      this.props.history.push('/noPermission/1')
    }
  }
}

export default BindingForm
